import { datadogRum } from '@datadog/browser-rum';
import cookie from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { LocalStorageService } from '~/core/utils/storage';

export function useDatadogSetUser() {
  const accessToken = cookie.get('accessToken');
  const impersonatorId = LocalStorageService.getItem('impersonatorId');
  const jwtUser: any = accessToken && (jwtDecode(accessToken) as any);

  useEffect(() => {
    datadogRum.setUser({
      id: jwtUser?.sub as string,
      name: jwtUser?.preferred_username as string,
      email: jwtUser?.email as string,
      roles: jwtUser?.realm_access?.roles as string,
      sonar: jwtUser?.sonar as string,
      ...(!!impersonatorId && { impersonatorId }),
    });
  }, [jwtUser, impersonatorId]);
}
